import { useAuth, AuthProvider } from "./services/auth";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Admin from "./pages/Admin";
import Home from './pages/Home'
import LicenseDetail from "./components/License/LicenseDetail"
import LicenseModelDetail from "./components/License/LicenseModelDetail"
import ExpiredLicenses from './components/Admin/SecondaryExpiredScreen/ExpiratedLicenses'
import ExpiringLicenses from './components/Admin/SecondaryExpiredScreen/ExpiringLicenses'
import License from './pages/License'
import Hardware from "./pages/HardwareAdmin"
import HardwareDetail from "./components/HardwareAdmin/HardwareDetail"
import Login from "./pages/Login"
import Logout from "./components/Login/Logout";
import CircularProgress from '@mui/material/CircularProgress';
import Navbar from "./components/Navbar";
import { Typography, Box, Grid } from "@mui/material";

function NotFound() {
    return (
        <Typography variant={"h4"}>{"Not Found"}</Typography>
    )
}

function Main() {
    let { isLogged, authLoading } = useAuth()

    if (authLoading) {
        return < div >
            <Box sx={{ display: 'flex' }} style={{ position: 'relative', top: '20rem', left: '50rem' }}>
                <CircularProgress />
            </Box>
        </div >
    }

    return (
        <Router>
            <Box>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Navbar/>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{paddingTop: 70}}>
                    {!isLogged ?
                        <Switch>
                            <Route path='/login' exact component={Login} />
                            <Redirect to='/login' />
                        </Switch>
                        :
                        <Switch>
                            <Redirect exact from="/" to="/licenses" />
                            <Route path='/home' exact component={Home} />
                            <Route path='/admin' exact component={Admin} />
                            <Route path='/expired-licenses' exact component={ExpiredLicenses} />
                            <Route path='/expiring-licenses' exact component={ExpiringLicenses} />
                            <Route path='/licenses' exact component={License} />
                            <Route path='/licenses/:id' exact component={LicenseDetail} />
                            <Route path='/license-types/:id' exact component={LicenseModelDetail} />
                            <Route path='/hardware' exact component={Hardware} />
                            <Route path='/hardware/:id' exact component={HardwareDetail} />
                            <Route path='/logout' exact component={Logout} />
                            <Route path='/login' exact component={Login} />
                            <Route component={NotFound} />
                        </Switch>

                    }
                </Grid>
            </Box>
        </Router>
    )
}

function App() {
    return (
        <AuthProvider>
            <Main />
        </AuthProvider>
    )
}

export default App;
